import { apiRequest } from "../network/Api";

export const LoginApi = (path, data) => {
    return apiRequest({
      method: "POST",
      url: path,
      data,
    });
  };


  export const VerifyOtpApi = (path, data) => {
    return apiRequest({
      method: "POST",
      url: path,
      data,
    });
  };

  export const UpdateUserApi = (path, data) => {
    return apiRequest({
      method: "PUT",
      url: path,
      data,
    });
  };

  export const CreateUserApi = (path, data) => {
    return apiRequest({
      method: "POST",
      url: path,
      data,
    });
  };

  export const ValidateEmail = (path, data) => {
    return apiRequest({
      method: "Post",
      url: path,
      data,
    });
  };

  export const ResendEmailOtp = (path, data) => {
    return apiRequest({
      method: "Post",
      url: path,
      data,
    });
  };

 //post api to get userList
  export const GetUserList = (path, data) => {
    return apiRequest({
      method: "Post",
      url: path,
      data,
    });
  };


  //post api to get userList
  export const GetCityList = (path, data) => {
    return apiRequest({
      method: "PUT",
      url: path,
      data,
    });
  };

   //post api to get userList
   export const createCity = (path, data) => {
    return apiRequest({
      method: "POST",
      url: path,
      data,
    });
  };
  

  //post api to get userList
  export const userDetailsApi = (path, data) => {
    return apiRequest({
      method: "POST",
      url: path,
      data,
    });
  };


  //disable the user
export const disableUser = (path,data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//api to update notificate read
export const notificationViewApi = (path,data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to get store details
export const storeDetails = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to get store details
export const createStoreDetails = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to get store details
export const createFaqApi = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to get enquire list
export const getEnquireList = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//put api to update faq data
export const updateFaq = (path, data) => {
  return apiRequest({
    method: "PUT",
    url: path,
    data,
  });
};

//post api to get store details
export const updateStoreDetails = (path, data) => {
  return apiRequest({
    method: "PUT",
    url: path,
    data,
  });
};

//post api to get draft store details
export const draftStoreDetails = (path, data) => {
  return apiRequest({
    method: "PUT",
    url: path,
    data,
  });
};

//post api to  buy shares
export const  buySharesApi = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to  buy shares
export const  emailsupport  = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to  buy shares
export const  getPresignedUrl  = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to  buy shares
export const  rejectApproval  = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

//post api to get userList
export const approveSellShare = (path, data) => {
  return apiRequest({
    method: "PUT",
    url: path,
    data,
  });
};

//post api to get userList
export const enquireListDetailedView = (path, data) => {
  return apiRequest({
    method: "PUT",
    url: path,
    data,
  });
};

//refreshToken 
export const callAccessToken = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const callDynamicValueEdit = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const callHomeDataEdit = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const callSeoValueEdit = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const callShareValueEdit = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const createShare = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const editShareApproved = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};

export const getAdminReport = (path, data) => {
  return apiRequest({
    method: "POST",
    url: path,
    data,
  });
};





